<template>
    <div class="my-cart">
        <navigation-bar Back />
        <div class="main">
            <!--TODO 線上點餐＋候位預約點餐 才有以下區塊-->
            <MealList :fromRoute="fromRoute" :takeoutId="takeoutId" ref="MealList" />

            <!--TODO 揪團點餐 才有以下區塊-->
            <!--        <template>
                        <div class="top-cart-list">
                            <h4>
                                我的訂單
                                <el-button type="text" @click="$router.push({name: 'OrderList'})">新增餐點</el-button>
                            </h4>

                            <user style="margin: 10px 20px 0;"></user>

                            <slip-del>
                                <meal toDetail></meal>
                                <div slot="del"><img src="@/assets/images/delete_white_line.svg"> </div>
                            </slip-del>
                            <slip-del>
                                <meal toDetail></meal>
                                <div slot="del"><img src="@/assets/images/delete_white_line.svg"> </div>
                            </slip-del>

                        </div>

                        <div class="shadow-line m-0"></div>
                        <el-collapse class="top-cart-list">
                            <el-collapse-item>
                                <h4 slot="title">
                                    看看其他人都點甚麼
                                    <span class="small">張大大等，共<b class="red">10</b>人</span>
                                </h4>
                                <div class="cart-list team-buying">
                                    <user></user>
                                    <meal></meal>
                                    <meal></meal>
                                </div>
                                <div class="cart-list team-buying">
                                    <user></user>
                                    <meal></meal>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                    </template>-->

            <!--        <div class="cart-recommend">
                        <div class="con">
                            <h4>推薦</h4>
                            &lt;!&ndash;TODO 推薦商品區塊&ndash;&gt;
                            <Recommend></Recommend>
                        </div>
                    </div>-->
            <DeliveryBlock :fromRoute="fromRoute" ref="DeliveryBlock" />

            <NoteBlock :fromRoute="fromRoute" ref="NoteBlock" />
            <div class="cart-list" v-if="!isTableOrderAddItem && (isCanMobileBarcode || isCanTaxIdNumber) && !isShowCashPayHint()">
                <h4 class="mt-3">發票資料</h4>
                <!--todo 手機條碼-->
                <MobileBarcode v-if="isCanMobileBarcode && false" @update="mobileBarcodeUpdate" :value="mobileBarcode"/>
                <!--todo 統一編號-->
                <tax-id-number v-if="isCanTaxIdNumber" @update="updateTaxIdNumber" :value="taxIdNumber" />
            </div>
            <div class="cart-list last" v-if="!isTableOrderAddItem">
                <template v-if="isRequestTableware && (isCordova || isOnlineOrder)">
                    <div class="d-flex">
                        <div class="flex-grow-1">
                            <div class="li dark">
                                <i class="el-icon-knife-fork" />請問你需要拋棄式餐具、吸管嗎？
                            </div>
                            <div class="li">
                                <span v-if="!isRequiredTableware">不用提供，我是環保小尖兵</span>
                                <span v-else>需要提供</span>
                            </div>
                        </div>
                        <div class="text-right">
                            <el-switch class="lg mt-3" v-model="isRequiredTableware"/>
                        </div>
                    </div>

                    <el-divider class="mt-3 mb-3" />
                </template>

                <h4>
                    給店家的話
                </h4>
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" :placeholder="remarkPrompt"
                          v-model="remark">
                </el-input>

                <div class="mt-3">
                    請注意：當按下「送出訂單」即表示成立訂單並同意服務條款及隱私條款。
                </div>
            </div>

            <!--TODO 更改付款方式-->
            <bank-card v-if="showBank" :paymentType="paymentType" :funcTypeId="2" @changePaymentType="changePaymentType" />

            <!--todo 刪除餐點彈框-->
            <el-dialog
                    :visible.sync="showDelDialog"
                    append-to-body
                    top="20%"
                    width="80%"
                    custom-class="commDialog"
                    @close="closeDelDialog">
                <div class="container">
                    <img src="../../assets/images/dialog-order.svg" class="icon">
                    <h4 class="text-center">確定要刪除此餐點？</h4>
                    <div class="dialog-footer">
                        <el-button @click="delMeal" type="info">確定刪除</el-button>
                    </div>
                </div>
            </el-dialog>

            <!--todo 結帳後彈框-->
            <el-dialog
                :visible.sync="finalCheckModel"
                append-to-body
                :show-close="false"
                class="dialog"
                custom-class="commDialog">
                <div class="container text-center">
                    <img src="@/assets/images/dialog-exchange.svg" class="mb-0 icon">
                    <div slot="title" class="outer-content p-0">
                        <!--todo 使用金流-->
                        <template v-if="false">付款</template>
                        <!--todo 使用店內付款-->
                        <template v-else>確認</template>後將無法進行任何修改
                    </div>
                    <p class="main-content mt-3 mb-3 min-w-140 text-left">
                        付款金額 : ${{finalPrice}}<br>
                        付款方式 : {{getPaymentName()}}
                    </p>
                    <!--todo 使用店內付款增加下面項目-->
                    <p class="red mb-0" v-if="isShowCashPayHint()">*需至櫃檯或自助點餐機付款</p>
                    <div slot="footer" class="dialog-footer">
                        <el-button type="info" @click="finalCheckModel=false">取消</el-button>

                        <!--todo 使用金流-->
                        <el-button type="warning" v-if="false">付款</el-button>

                        <!--todo 使用店內付款-->
                        <el-button type="warning" v-else @click="onClickPayRightNow">確定</el-button>
                    </div>
                </div>
            </el-dialog>

            <el-dialog
                :visible.sync="checkPaymentCompletedDialog"
                append-to-body
                custom-class="commDialog"
                :show-close="false"
            >
                <div class="container line-pay">
                    <img src="../../assets/images/pay/other_pay_linepay2.svg" class="linepay-logo">
                    <h5 class="dark">操作支付中</h5>
                    <p class="dark">支付期間請勿關閉彈窗</p>
                    <div class="dialog-footer">
                        <el-button @click="openLinePay" type="warning">繼續</el-button>
                    </div>

                    <el-button @click="checkPaymentCompletedDialog = false" type="text" class="text-btn">改其他方式支付</el-button>


                    <el-button @click="checkPaymentCompleted(false)" type="text" class="position-absolute"><i class="el-icon-refresh"/>重整</el-button>

                </div>
            </el-dialog>

            <!--todo 取消揪團後，被分享者要出現彈框-->
            <!--<el-dialog
                    :visible.sync="showModel"
                    top="20%"
                    width="80%"
                    :show-close="false"
                    :close-on-click-modal="false"
                    custom-class="commDialog">
                <div class="container">
                    <img src="@/assets/images/dialog-order.svg">
                    <p class="text-center">主揪已取消揪團<br>但您的訂單還是被保留可繼續下訂</p>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="showModel=false" type="info">繼續</el-button>
                    </div>
                </div>
            </el-dialog>-->
            <loading :active.sync=isLoading :can-cancel="false" :is-full-page="true">
            </loading>
        </div>
        <!--TODO 候位預約點餐出現區塊-->
        <!--        <cart-button toRecord v-if="false"
                        :message='"送出預點清單"'/>-->

        <!--TODO 揪團點餐-主揪 出現區塊-->
        <!--        <cart-button :message="'送出訂單'" toRecord isShare isInvite isOrder isCancel></cart-button>-->
        <!--TODO 揪團點餐-被分享者 出現區塊-->
        <!--        <cart-button :message="'送出訂單'" isShare isOrder isQuit v-if="false"></cart-button>-->

        <!--TODO 送出訂單出現彈框 點餐成功彈框（QR碼點餐還是維持原有流程）-->
        <template v-if="isTableOrderAddItem">
            <cart-button
                    :totalPrice="finalPrice"
                    :totalAmount="sumAmount"
                    :submitToDo="tableOrderAddItem"
                    :message='"送出訂單"'/>
        </template>
        <!--TODO 按結帳後彈出最後確定彈窗（APP線上點餐＋Web版桌邊點餐走這個流程）-->
        <template v-else>
            <cart-button
                    :totalPrice="finalPrice"
                    :totalAmount="sumAmount"
                    :submitToDo="finalCheck"
                    :message='"結帳"'/>
        </template>
    </div>
</template>

<script>

import CartButton from '@/views/order/components/CartButton';
import MealList from '@/views/order/components/MealList';
import DeliveryBlock from '@/views/order/components/DeliveryBlock';
import NoteBlock from '@/views/order/components/NoteBlock';
import BankCard from '@/views/order/components/BankCard';
//import User from '@/views/order/components/User'
//import Recommend from '@/views/order/components/Recommend'
import { notNull } from '@/util/common';
import * as mutationTypes from "@/store/mutationTypes";
import * as constDefine from '@/store/constDefine';
import TaxIdNumber from "../../components/TaxIdNumber";
import MobileBarcode from "../../components/MobileBarcode";
import Analytics from '@/util/analytics';
import {getCryptoUserInfo} from "@/util/cryptoLocalStorage";
import {PayType} from "@/store/constDefine";

export default {
    name: "OrderCart",
    components: {
        CartButton,//底下按鈕
        MealList,
        DeliveryBlock,
        NoteBlock,
        BankCard,//更改付款方式
        //User,//揪團大頭貼
        //Recommend,//推薦商品區塊
        TaxIdNumber,//統一編號
        MobileBarcode,//手機條碼
    },
    data() {
        return {
            orderSettingTypeId: this.$store.state.cartPageSnapshot.orderSettingTypeId,
            isLoading: false,
            orderSn: "",
            radioTake: this.$store.state.cartPageSnapshot.radioTake,         //取餐方式
            showBank: this.$store.state.cartPageSnapshot.showBank,        //更改付款方式

            paymentType: this.$store.state.cartPageSnapshot.paymentType,
            showModel: false,       //取消揪團時，被分享者要出現的提示
            finalCheckModel: false,   //訂單送出前確認彈框
            fareModel: this.$store.state.cartPageSnapshot.fareModel,       //外送費說明彈框
            payModel: this.$store.state.cartPageSnapshot.payModel,        //付款說明彈框
            showDelDialog: false,   //刪除餐點彈框

            scrollHeight: this.$store.state.cartPageSnapshot.scrollHeight,
            scrollTop: this.$store.state.cartPageSnapshot.scrollTop,
            storeId: Number(this.$route.query.storeId ? this.$route.query.storeId : this.$store.state.cartStoreId),//店家id(query過來的是修改訂單)
            shoppingCartMealChoiceList: this.$store.state.cartPageSnapshot.shoppingCartMealChoiceList, //購物車中的餐點資訊
            shoppingCartMealData: this.$store.state.cartPageSnapshot.shoppingCartMealData,       //所有餐點資料
            refreshChoiceList: this.$store.state.cartPageSnapshot.refreshChoiceList,
            delMealIndex: null,     //暫存正在被刪除的餐點
            delMealOldVal: null,    //刪除前的數量
            delMealArr: [],         //紀錄被刪除的餐點
            originTotalPrice: this.$store.state.cartPageSnapshot.originTotalPrice,    //小計
            oldOriginTotalPrice: this.$store.state.cartPageSnapshot.oldOriginTotalPrice, //用優惠前小計
            sumAmount: 0,           //總餐點數量
            couponList: this.$store.state.cartPageSnapshot.couponList,         //優惠表
            discountLimit: this.$store.state.cartPageSnapshot.discountLimit,        //優惠限制設定
            concatCouponList: this.$store.state.cartPageSnapshot.concatCouponList,    //是否拼接優惠表
            couponChoiceList: this.$store.state.cartPageSnapshot.couponChoiceList,       //已選擇的優惠券選項
            couponChoiceListItem: this.$store.state.cartPageSnapshot.couponChoiceListItem,   //已選擇的優惠券
            calculatorCouponPrice: this.$store.state.cartPageSnapshot.calculatorCouponPrice,    //計算經過coupon的金額
            orderGift: this.$store.state.cartPageSnapshot.orderGift,      //可獲得票券
            taxIdNumber: this.$store.state.cartPageSnapshot.taxIdNumber,    //統一編號
            mobileBarcode: this.$store.state.cartPageSnapshot.mobileBarcode,    //手機載具
            remark: this.$store.state.cartPageSnapshot.remark,         //訂單備註

            storeInfo: this.$store.state.cartPageSnapshot.storeInfo,
            userAddressData: this.$store.state.cartPageSnapshot.userAddressData,
            userAddressId: this.$store.state.cartPageSnapshot.userAddressId,
            userAddressParams: this.$store.state.cartPageSnapshot.userAddressParams,
            deliveryConditionList: this.$store.state.cartPageSnapshot.deliveryConditionList,//外送費資訊
            maxDistance: this.$store.state.cartPageSnapshot.maxDistance,//最大運送距離
            isRequiredRemark: this.$store.state.cartPageSnapshot.isRequiredRemark,//訂單備註欄位是否必填
            isRequestTableware: this.$store.state.cartPageSnapshot.isRequestTableware,//是否顯示需要拋棄式餐具、吸管嗎？
            isRequiredTableware: this.$store.state.cartPageSnapshot.isRequiredTableware,//是否需要拋棄式餐具、吸管
            remarkPrompt: this.$store.state.cartPageSnapshot.remarkPrompt,//訂單備註欄位提示
            checkoutInstructions: this.$store.state.cartPageSnapshot.checkoutInstructions,//結帳說明
            isCanCoupon: this.$store.state.cartPageSnapshot.isCanCoupon,//顯示優惠券使用欄位(開啟時，可提供顧客使用優惠券)
            isCanTaxIdNumber: this.$store.state.cartPageSnapshot.isCanTaxIdNumber,//顯示統一編號輸入欄位(開啟時，可提供顧客輸入統編)
            isCanMobileBarcode: this.$store.state.cartPageSnapshot.isCanMobileBarcode,//顯示手機條碼輸入欄位(開啟時，可提供顧客輸入手機條碼)
            mealPreparationTimeType: this.$store.state.cartPageSnapshot.mealPreparationTimeType,//餐點平均準備時間
            orderDeliveryList: this.$store.state.cartPageSnapshot.orderDeliveryList,//取餐方式（自取、外送、小短腿）
            completeOrderData: this.$store.state.cartPageSnapshot.completeOrderData,

            takeoutId: Number(this.$store.state.cartPageSnapshot.takeoutId ? this.$store.state.cartPageSnapshot.takeoutId : (this.$route.query.takeoutId ? this.$route.query.takeoutId : 0)),//我想修改訂單回來帶入參數
            orderTmpId: this.$store.state.cartPageSnapshot.orderTmpId, //暫時訂單編號
            openUrl: this.$store.state.cartPageSnapshot.openUrl,
            routerGoEnable: this.$store.state.cartPageSnapshot.routerGoEnable,
            deliveryFee: this.$store.state.cartPageSnapshot.deliveryFee,
            removeSubscribe: {},

            fromRoute: null, //(不可寫進vuex)此為上一頁的路由
            timeoutID: 0,
            checkCumulativeTypeList: {},
            orderSnOCP: '',  //OCP電子錢包回傳訂單編號用

            isCordova: this.$public.isCordova(),
            isOnlineOrder: Boolean(sessionStorage.getItem("isOnlineOrder")),
            dataObject: {},
            phone: '',
            tableId: 0,
            adult: 0,
            child: 0,
            digitalPayErrStr: "",       //線上金流錯誤訊息
            isTableOrderAddItem: false,
            orderId: 0,
            isTableOrderComplete: false,
            orderRewardPointInfo: { //點餐的紅利點數相關資料
                rewardPointList: this.$store.state.cartPageSnapshot.orderRewardPointInfo.rewardPointList,
                rewardPointTakeoutList: this.$store.state.cartPageSnapshot.orderRewardPointInfo.rewardPointTakeoutList,
                rewardPointDeliveryList: this.$store.state.cartPageSnapshot.orderRewardPointInfo.rewardPointDeliveryList,
                rewardPointTableList: this.$store.state.cartPageSnapshot.orderRewardPointInfo.rewardPointTableList,
                useRewardPointIdList: this.$store.state.cartPageSnapshot.orderRewardPointInfo.useRewardPointIdList,
                isLimitDiscountShare: this.$store.state.cartPageSnapshot.orderRewardPointInfo.isLimitDiscountShare,
            },
            payment: {},
            payResult: '',
            payPassword: "",
            isUserData: false,
            isAppScanOpen: false,
            isNoteBlock: false,
            noteBlockTimer: {},

            analytics: null,
            countryCode: '+886',
            countryName: 'TW',
            isMobile: false,
            signalController: null,
            checkPaymentCompletedDialog: false,
            newOrderTmpId: 0,
            payExecuteType: 0,
            payExecuteId: 0,
            paymentUrlApp: "",
            paymentUrlWeb: "",
            constDefinePayType: constDefine.PayType,
            checkPaymentCompletedTimer: {},
        }
    },
    created() {
        this.isMobile = this.$public.isMobile();
        if (!this.isCordova) {
            try {
                this.dataObject = this.$crypto.uriComponentToObject(sessionStorage.getItem(constDefine.StorageNameType.TableOrderDataToken));
                if (this.dataObject.isChecked) {
                    this.storeId = Number(this.dataObject.storeId);
                    this.phone = this.dataObject.phone;
                    this.tableId = Number(this.dataObject.tableId);
                    this.adult = Number(this.dataObject.adult);
                    this.child = Number(this.dataObject.child);
                    this.countryCode = this.dataObject.countryCodeData !== undefined ? this.dataObject.countryCodeData.code : "+886";
                    this.countryName = this.dataObject.countryCodeData !== undefined ? this.dataObject.countryCodeData.enName : "TW";

                    if (this.dataObject.usedType === constDefine.QRCodeUsedType.TableOrderAddItem) {
                        this.isTableOrderAddItem = true
                        this.orderId = Number(this.dataObject.orderId);
                        this.tableId = Number(this.dataObject.tableId);
                    } else if (this.dataObject.usedType === constDefine.QRCodeUsedType.TableOrder && typeof this.dataObject.userData !== "undefined") {
                        this.isUserData = true;
                        this.isAppScanOpen = this.dataObject?.isAppOpen || false;
                    }

                    // NOTE 避免網頁版重整異常
                    if (this.$store.state.cartStoreId === 0) {
                        this.$store.commit('setCartStoreId', this.storeId);
                    }

                } else {
                    if (this.dataObject.routePath) {
                        this.$router.push({ path: this.dataObject.routePath })
                    } else {
                        this.$router.push({ name: 'Error' });
                    }
                    return false;
                }
            } catch (e) {
                if (!this.isOnlineOrder) {
                    this.$router.push({ name: 'Error' });
                    return false;
                }
            }
        }

        if (this.isTableOrderAddItem) {
            this.analytics = Analytics.getInstance(this.$route, "QRCodeOrder");
        } else if (this.isOnlineOrder) {
            this.analytics = Analytics.getInstance(this.$route, "OnlineOrder");
        } else {
            this.analytics = Analytics.getInstance(this.$route, "TableOrder");
        }

        //錢包支付完從記錄回來時就導到OrderList
        if (notNull(this.$store.state.pageSnapshot["payRelationData"]) && this.storeId === 0 && this.$store.state.pageSnapshot["payRelationData"].storeId > 0) {
            let payRelationData = this.$store.state.pageSnapshot["payRelationData"]
            this.$store.commit("savePageSnapshot", {routeName: "payRelationData", variable: undefined});
            this.$router.replace({name: 'OrderList', query: {id: payRelationData.storeId}})
        } else {
            this.$store.commit("savePageSnapshot", {routeName: "payRelationData", variable: undefined});
        }

        //等0.3秒抓beforeRouteEnter
        setTimeout(() => {
            this.$refs["MealList"].setupData();
            if (this.isCordova || this.isOnlineOrder) {
                this.$refs["DeliveryBlock"].setupData();
                this.$refs["NoteBlock"].setupData();
                this.isNoteBlock = true
            } else if (this.isUserData) {
                this.$refs["NoteBlock"].setupData();
                this.isNoteBlock = true
            }
            this.setupData();
        }, 300);

        this.$store.commit("trigerCartDelDialog", {
            showDelDialog: false,
            delMealIndex: null,
            delMealOldVal: null,
        });
    },
    mounted() {
        this.removeSubscribe = this.$store.subscribe((mutation, state) => {
            if (mutation.type === mutationTypes.setOrderStoreInfo) {
                this.storeInfo = state.orderStoreInfo
            }

            if (mutation.type === "updateShoppingCartMealChoiceList") {
                this.shoppingCartMealChoiceList = mutation.payload;
            }
            if (mutation.type === "trigerCartDelDialog") {
                this.showDelDialog = mutation.payload.showDelDialog;
                this.delMealIndex = mutation.payload.delMealIndex;
                this.delMealOldVal = mutation.payload.delMealOldVal;
            }
            if (mutation.type === "updateCartTaxIdNumber") {
                this.taxIdNumber = mutation.payload;
            }
            if (mutation.type === "updateCartMobileBarcode") {
                this.mobileBarcode = mutation.payload;
            }

            if (mutation.type === "updateCartCalculatorCouponPrice") {
                this.calculatorCouponPrice = mutation.payload;
            }
            if (mutation.type === "updateCartCouponList") {
                this.couponList = mutation.payload;
            }
            if (mutation.type === "updateCartDiscountLimit") {
                this.discountLimit = mutation.payload;
            }
            if (mutation.type === "updateCartShowBank") {
                this.showBank = mutation.payload;
            }
            if (mutation.type === "updateCartRadioTake") {
                this.radioTake = mutation.payload;
            }
            if (mutation.type === "updateCartDeliveryFee") {
                this.deliveryFee = mutation.payload;
            }
            if (mutation.type === "updateCartUserAddressData") {
                this.userAddressData = mutation.payload;
            }
            if (mutation.type === mutationTypes.setOrderRewardPointInfo) {
                this.orderRewardPointInfo = { //點餐的紅利點數相關資料
                    rewardPointList: this.$store.state.cartPageSnapshot.orderRewardPointInfo.rewardPointList,
                    rewardPointTakeoutList: this.$store.state.cartPageSnapshot.orderRewardPointInfo.rewardPointTakeoutList,
                    rewardPointDeliveryList: this.$store.state.cartPageSnapshot.orderRewardPointInfo.rewardPointDeliveryList,
                    rewardPointTableList: this.$store.state.cartPageSnapshot.orderRewardPointInfo.rewardPointTableList,
                    useRewardPointIdList: this.$store.state.cartPageSnapshot.orderRewardPointInfo.useRewardPointIdList,
                    isLimitDiscountShare: this.$store.state.cartPageSnapshot.orderRewardPointInfo.isLimitDiscountShare,
                }
            }
            if (mutation.type === mutationTypes.setOrderSettingTypeId) {
                this.orderSettingTypeId = mutation.payload;
            }
        })

        if (localStorage.getItem('routerGoEnable') === 1) {
            localStorage.removeItem('routerGoEnable');
            this.$router.go(-1);
        }

        let checkCumulativeTypeList = {}

        this.couponChoiceListItem.forEach(item => {
            let couponListId = "couponListId_" + item.couponListId
            if (item.posUseType === 2) {
                let newItem = JSON.parse(JSON.stringify(item))
                if (typeof checkCumulativeTypeList[couponListId] === "undefined") {
                    newItem.totalChoiceAmount = item.choiceAmount;
                } else {
                    newItem.totalChoiceAmount = checkCumulativeTypeList[couponListId].totalChoiceAmount + item.choiceAmount
                }
                checkCumulativeTypeList[couponListId] = newItem
            }
        })

        this.checkCumulativeTypeList = checkCumulativeTypeList
    },
    destroyed() {
        this.removeSubscribe();
        if (this.timeoutID !== 0) {
            window.clearInterval(this.timeoutID);
        }

        if (this.signalController !== null) {
            this.signalController.abort()
        }

        clearTimeout(this.checkPaymentCompletedTimer)
        document.removeEventListener("visibilitychange", this.callCheckPaymentCompleted);
    },
    methods: {
        setupData() {
            let mealChoiceListTable = '';   //sql_ite餐點選擇狀態資料表名稱
            let mealDataTable = '';     //sql_lite參點資料的資料表名稱
            //判斷是否為修改訂單
            if (this.takeoutId !== 0) {
                mealChoiceListTable = 'order_record_meal_choiceList';
                mealDataTable = 'order_record_meal_data';
            } else {
                mealChoiceListTable = 'shopping_cart_meal_choiceList';
                mealDataTable = 'shopping_cart_meal_data';
            }
            // 把變數還原到離開前的狀態
            // if ((notNull(this.fromRoute) && ['OrderCouponList','OrderDetail','OrderAddressList','EditOrderList'].indexOf(this.fromRoute.name) !== -1)&&notNull(this.$store.state.pageSnapshot[this.$route.name])) {
            //         for (const key in snapshotdata) {
            //             if (Object.hasOwnProperty.call(snapshotdata, key)) {
            //                 const element = snapshotdata[key];
            //                 this[key] = element;

            //             }
            //         }
            // }
            if (notNull(this.fromRoute) && ['OrderCouponList', 'OrderDetail', 'OrderAddressList', 'OINPay', 'PayPassword'].indexOf(this.fromRoute.name) !== -1) {  // 渲染完成後等一下才捲到目標位置(5)
                this.$nextTick(function () {
                    if (this.scrollTop !== '') {
                        let finish = false;
                        let count = 0;
                        this.timeoutID = setInterval(() => {
                            // 當高度與離開前相等捲到先前高度（有時候選擇器會選不到）
                            if (document.querySelector('.main') !== null && (Math.abs(this.scrollHeight - document.querySelector('.main').scrollHeight) < 200)) {
                                document.querySelector('.main').scrollTo(0, this.scrollTop);
                                this.scrollTop = '';
                                finish = true;
                            }
                            count = count + 1;
                            if (finish || count > 200) {
                                window.clearInterval(this.timeoutID);
                            }
                        }, 20);
                    }
                });
            }
            if (notNull(this.fromRoute) && ['OrderHelp'].indexOf(this.fromRoute.name) !== -1 && this.takeoutId !== 0) {  //從訂單明細點修改訂單過來，購物車顯示訂單資料(9)
                let orderRecord = undefined;
                this.$sqlite.query('select * from order_record_snapshot_data WHERE takeoutId = ?', [this.takeoutId], (resultSet) => {
                    if (resultSet.rows.length > 0) {
                        orderRecord = JSON.parse(resultSet.rows.item(0).data_json);
                        //購物車畫面上所有變數回到訂單的狀態
                        for (const key in orderRecord) {
                            if (Object.hasOwnProperty.call(orderRecord, key) && key !== 'concatCouponList') {
                                const element = orderRecord[key];
                                this[key] = element;

                            }
                        }

                        this.$store.commit(mutationTypes.setOrderStoreInfo, this.storeInfo);
                        this.$store.commit("updateCartPaymentType", this.paymentType);
                        this.$store.commit("updateCartTaxIdNumber", this.taxIdNumber);
                        this.$store.commit("updateCartMobileBarcode", this.mobileBarcode);
                        this.$store.commit("updateShoppingCartMealData", this.shoppingCartMealData);
                        this.$store.commit("updateShoppingCartMealChoiceList", this.shoppingCartMealChoiceList);
                        this.$store.commit("updateCartCouponChoiceList", this.couponChoiceList);
                        this.$store.commit("updateCartcouponChoiceListItem", this.couponChoiceListItem);
                        this.$store.commit("updateCartDiscountLimit", this.discountLimit);
                        //全部餐點選項寫進 order_record_meal_choiceList
                        for (const key in this.shoppingCartMealChoiceList) {
                            if (Object.hasOwnProperty.call(this.shoppingCartMealChoiceList, key)) {
                                const element = this.shoppingCartMealChoiceList[key];
                                this.$sqlite.insert('insert into order_record_meal_choiceList (takeoutId,amount,choicePrice,meal_id,combination_json) values (?, ?, ?, ?, ?);', [this.takeoutId, element.amount, element.choicePrice, element.meal_id, element.combination_json], (resultSet) => { });
                            }
                        }
                        //全部餐點資料寫進 order_record_meal_data
                        for (const key in this.shoppingCartMealData) {
                            if (Object.hasOwnProperty.call(this.shoppingCartMealData, key)) {
                                const element = this.shoppingCartMealData[key];
                                this.$sqlite.insert('insert into order_record_meal_data (takeoutId,meal_id,data_json) values(?, ?, ?);', [this.takeoutId, element.meal_id, element.data_json], (resultSet) => { });
                            }
                        }
                    }
                });
            }

            if (notNull(this.fromRoute) && ['OrderCouponList', 'OrderDetail', 'OrderAddressList', 'EditOrderList', 'OINPay', 'PayPassword'].indexOf(this.fromRoute.name) === -1) {  // 載入線上點餐相關設定(7)
                this.$http.fetchWithAuth`GetOnlineOrderAndOtherSetting${{
                    'storeId': this.storeId,
                }}
                    ${json => {
                        if (json.status) {
                            if (notNull(json.data)) {
                                let data = json.data;
                                this.deliveryConditionList = data.deliveryConditionList.filter(item => item.status);
                                this.maxDistance = data.maxDistance;

                                this.remarkPrompt = data.storeInfo.remarkPrompt;
                                this.isRequiredRemark = data.storeInfo.isRequiredRemark;
                                this.isRequestTableware = data.storeInfo.isRequestTableware;
                                this.checkoutInstructions = data.storeInfo.checkoutInstructions;
                                this.isCanCoupon = data.storeInfo.isCanCoupon;
                                this.isCanTaxIdNumber = data.storeInfo.isCanTaxIdNumber;
                                this.isCanMobileBarcode = data.storeInfo.isCanCarrierNumber;
                                this.mealPreparationTimeType = data.storeInfo.mealPreparationTimeType;
                                this.orderDeliveryList = data.storeInfo.orderDeliveryList;

                                if (this.$store.state.orderStoreInfo.reservationTime === '' ||
                                    (!this.isCordova && typeof this.$store.state.orderStoreInfo.reservationTime === "undefined")) {
                                    this.storeInfo = json.data.storeInfo;
                                    this.$store.commit(mutationTypes.setOrderStoreInfo, this.storeInfo);
                                } else {
                                    this.storeInfo = this.$store.state.orderStoreInfo
                                }

                                this.radioTake = this.$store.state.orderStoreInfo.reservationType || this.radioTake
                                this.$store.commit("updateCartRadioTake", this.radioTake);
                                if (this.takeoutId === 0) {
                                    this.userAddressData = json.data.userAddressData;
                                }
                                // this.paymentMethod = json.data.paymentMethod;
                                this.$store.commit("updateCartOnlineOrderAndOtherSetting", {
                                    deliveryConditionList: this.deliveryConditionList,
                                    maxDistance: this.maxDistance,
                                    remarkPrompt: this.remarkPrompt,
                                    isRequiredRemark: this.isRequiredRemark,
                                    isRequestTableware: this.isRequestTableware,
                                    checkoutInstructions: this.checkoutInstructions,
                                    isCanCoupon: this.isCanCoupon,
                                    isCanTaxIdNumber: this.isCanTaxIdNumber,
                                    isCanMobileBarcode: this.isCanMobileBarcode,
                                    mealPreparationTimeType: this.mealPreparationTimeType,
                                    orderDeliveryList: this.orderDeliveryList,
                                    storeInfo: this.storeInfo,
                                    userAddressData: this.userAddressData,
                                    // paymentMethod:this.paymentMethod,
                                });
                                this.$store.commit("updateCartUserAddressId", this.userAddressData.id)
                                this.userAddressId = this.userAddressData.id

                                if (typeof this.userAddressParams.storeId !== "undefined" && this.userAddressParams.storeId > 0) {
                                    this.userAddressData.id = -1
                                    this.$store.commit("updateCartUserAddressId", this.userAddressData.id)
                                    this.userAddressId = this.userAddressData.id
                                    this.$refs["DeliveryBlock"].setupData();
                                }
                            }
                        }
                    }}`;
            }

            //取得支付密碼
            if (notNull(this.fromRoute) && ['PayPassword'].indexOf(this.fromRoute.name) !== -1) {
                try {
                    let paramsObject = this.$crypto.uriComponentToObject(this.$route.params.paramsToken)
                    if (paramsObject.usedType === this.$route.name && paramsObject.validTimestamp >= new Date().getTime()) {
                        this.payPassword = paramsObject.payPassword;
                        this.submitToDo()
                    }
                } catch(e) {
                    this.payPassword = ""
                }
            }
        },

        /** 點擊店內結帳按鈕 */
        onClickPayRightNow() {
            this.finalCheckModel = false;

            //檢查載具與統編
            let errorCode = this.checkBarcodeAndTaxId();
            if (errorCode === 0) {
                this.submitToDo();

            } else if (errorCode === 1) {
                this.$public.showNotify("請檢查手機條碼或統一編號是否填寫正確", false);
            } else if (errorCode === 2) {
                this.$public.showNotify("手機條碼或統一編號只能擇一填寫", false);
            }
        },

        // 確定刪除餐點按鈕(按鈕會觸發彈框關閉事件)
        delMeal() {
            //在準備刪除的陣列新增確定刪除的餐點
            this.delMealArr.push(this.shoppingCartMealChoiceList[this.delMealIndex]);
            //頁面上的陣列移掉刪除的餐點
            this.shoppingCartMealChoiceList.splice(this.delMealIndex, 1);
            this.$store.commit("updateShoppingCartMealChoiceList", this.shoppingCartMealChoiceList);

            this.delMealIndex = null;
            this.showDelDialog = false;

            this.$store.commit("trigerCartDelDialog", {
                showDelDialog: false,
                delMealIndex: null,
                delMealOldVal: null,
            });
        },
        // 刪除餐點防呆彈框關閉事件
        closeDelDialog() {
            if (notNull(this.delMealOldVal) && notNull(this.$refs['MealList'].$refs['setMeal'][this.delMealIndex])) {
                this.$refs['MealList'].$refs['setMeal'][this.delMealIndex].setNum(this.delMealOldVal);
            }
            this.delMealIndex = null;
            this.delMealOldVal = null;
        },
        // 送出訂單回傳的彈框關閉事件
        closeSuccessDialog() {
            //因為調整成購物車回點餐列表也是快照，所以新增完訂單要清快照
            this.$store.commit("savePageSnapshot", { routeName: "OrderList", variable: undefined });
            if (this.orderSn === '') {
                this.$router.replace({ name: 'OrderRecordList' });
            } else {
                this.$router.replace({ name: 'OrderRecordDetail', query: { orderSn: this.orderSn } });
            }
        },
        updateShopCart() {
            //判斷是否為修改訂單
            let mealChoiceListTable = '';
            let mealDataTable = '';
            if (this.takeoutId !== 0) {
                mealChoiceListTable = 'order_record_meal_choiceList';
                mealDataTable = 'order_record_meal_data';
            } else {
                mealChoiceListTable = 'shopping_cart_meal_choiceList';
                mealDataTable = 'shopping_cart_meal_data';
            }
            //更新餐點選項
            let hasMealIdArray = [];
            for (const key in this.shoppingCartMealChoiceList) {
                if (Object.hasOwnProperty.call(this.shoppingCartMealChoiceList, key)) {
                    const element = this.shoppingCartMealChoiceList[key];
                    if (this.isCordova) {
                        this.$sqlite.update('UPDATE ' + mealChoiceListTable + ' SET amount=?, choicePrice=?, text_note=? WHERE id = ?', [element.amount, element.choicePrice, element.text_note, element.id], function (resultSet) { });
                    } else {
                        //桌邊服務目前沒有建立記錄表，所以一律先跑原表
                        if (!this.isTableOrderComplete) {
                            this.$sqlite.updateDB("shopping_cart_meal_choiceList", [element], function (resultSet) { });
                            hasMealIdArray.push(element.meal_id)
                        }
                    }
                }
            }
            //刪除餐點選項
            this.delMealArr.forEach((element, index) => {
                if (this.isCordova) {
                    this.$sqlite.delete('delete from ' + mealChoiceListTable + '  where id = ?', [element.id], (resultSet) => {
                        delete this.delMeal[index];
                    });
                } else {
                    //桌邊服務目前沒有建立記錄表，所以一律先跑原表
                    if (!this.isTableOrderComplete) {
                        this.$sqlite.deleteDB("shopping_cart_meal_choiceList", "", element.id, (resultSet) => {
                            delete this.delMeal[index];
                        })
                    }
                }
            });

            //刪除沒有被放在選項裏的餐點資料
            if (this.isCordova) {
                this.$sqlite.delete('delete from ' + mealDataTable + ' where not exists (select id from ' + mealChoiceListTable + ' where ' + mealChoiceListTable + '.meal_id=' + mealDataTable + '.meal_id)', [], function (resultSet) { });
            } else {
                //桌邊服務目前沒有建立記錄表，所以一律先跑原表
                if (!this.isTableOrderComplete) {
                    this.$sqlite.queryDB("shopping_cart_meal_data", "", "", (resultSet) => {
                        let length = resultSet.length;
                        if (length > 0) {
                            for (let i = 0; i < length; i++) {
                                let item = resultSet[i];
                                if (hasMealIdArray.indexOf(item.meal_id) === -1) {
                                    this.$sqlite.deleteDB("shopping_cart_meal_data", "meal_id", item.meal_id, (resultSet) => {
                                    })
                                }
                            }
                        }
                    })
                }
            }
        },
        // api格式餐點資料
        mealApiFormat() {
            let apiFormatData = [];
            // 餐點選項
            this.shoppingCartMealChoiceList.forEach((item) => {
                let mealDataDetail = null;
                // 找到此選項所選餐點資訊
                for (const key in this.shoppingCartMealData) {
                    if (Object.hasOwnProperty.call(this.shoppingCartMealData, key)) {
                        const element = this.shoppingCartMealData[key];
                        if (element.meal_id === item.meal_id) {
                            mealDataDetail = element;
                        }
                    }
                }
                // 找的到就繼續
                if (notNull(mealDataDetail)) {
                    // 選項組合
                    let combination = JSON.parse(item.combination_json);
                    // 餐點詳細資料
                    let detailList = JSON.parse(mealDataDetail.data_json);
                    let temp = {
                        id: detailList.posFoodInfo.id,
                        name: detailList.posFoodInfo.onlineOrderName,
                        orderType: detailList.posFoodInfo.orderType,
                        amount: item.amount,
                        choicePrice: item.choicePrice,
                        textNote: item.text_note,
                        isCouponUse: item.isCouponUse,
                        couponTypeId: item.couponTypeId,
                        executeType: item.executeType,
                        executeData: item.executeData,
                        posFoodSubmealList: function () {
                            if (detailList.posFoodInfo.orderType === 2) {
                                let tempSubMealList = [];
                                combination[0].forEach((combinationItem, combinationIndex) => {
                                    let mealSet = detailList.dataList[combinationIndex];
                                    let subMealInfo = mealSet.posFoodSubmealList[combinationItem];
                                    let tempSubMeal = {
                                        mealSetId: mealSet.id,
                                        mealSetName: mealSet.name,
                                        mealSetQuantity: mealSet.quantity,
                                        posFoodId: subMealInfo.posFoodId,
                                        posFoodName: subMealInfo.posFoodName,
                                        increasePrice: subMealInfo.increasePrice,
                                        posFoodSubmealId: subMealInfo.posFoodSubmealId,
                                        // 餐點註記選項
                                        PosGoodsNoteDetailList: function () {
                                            let tempNoteList = [];
                                            combination[1][combinationIndex][combinationItem].forEach((combinationNoteItem, combinationNoteIndex) => {
                                                // 過濾掉沒有選的
                                                if (combinationNoteItem.length > 0) {
                                                    let tempNote = subMealInfo.posFoodGoodsNoteList[combinationNoteIndex];
                                                    // 過濾掉沒有選的
                                                    tempNote.posGoodsNoteDetailList = tempNote.posGoodsNoteDetailList.filter((tempNoteItem, tempNoteIndex) => { return combinationNoteItem.indexOf(tempNoteIndex) !== -1; });
                                                    tempNoteList.push(...tempNote.posGoodsNoteDetailList);
                                                }
                                            });
                                            return tempNoteList;
                                        }(),
                                    };
                                    tempSubMealList.push(tempSubMeal);
                                });
                                return tempSubMealList;
                            }
                        }(),
                        PosGoodsNoteDetailList: function () {
                            if (detailList.posFoodInfo.orderType === 1) {
                                let tempNoteList = [];
                                combination.forEach((combinationItem, combinationIndex) => {
                                    // 過濾掉沒有選的
                                    if (combinationItem.length > 0) {
                                        let tempNote = detailList.dataList[combinationIndex];
                                        // 過濾掉沒有選的
                                        tempNote.posGoodsNoteDetailList = tempNote.posGoodsNoteDetailList.filter((tempNoteItem, tempNoteIndex) => { return combinationItem.indexOf(tempNoteIndex) !== -1; });
                                        tempNoteList.push(...tempNote.posGoodsNoteDetailList);
                                    }
                                });
                                return tempNoteList;
                            }
                        }(),
                        PosFoodInfo: {
                            id: detailList.posFoodInfo.id,
                            onlineOrderName: detailList.posFoodInfo.onlineOrderName,
                            orderType: detailList.posFoodInfo.orderType,
                            amount: item.amount,
                            choicePrice: item.choicePrice,
                            textNote: item.text_note,
                        },
                    };
                    apiFormatData.push(temp);
                }
            });
            return apiFormatData;
        },
        changePaymentType(val) {
            if (val.type === "tokenPayNewebpayMPG") {
                if (val.isHaveToken && val.isHavePayPassword) {
                    this.$store.commit("updateCartPaymentType", val);
                    //這寫法會保留沒異動的值，使用上需嚴謹
                    this.paymentType = Object.assign({}, this.paymentType, val);
                    this.showBank = false;
                } else {
                    let routerName = ""
                    if (!val.isHaveToken) {
                        routerName = "OINPay"
                    } else {
                        routerName = "PayPassword"
                    }

                    let dataToken = this.$crypto.objectToURIComponent({
                        usedType: routerName,
                        isHavePayPassword: val.isHavePayPassword,
                        successRouterName: this.$route.name,
                    })

                    this.$router.push({name: routerName, query: {'dataToken': dataToken}})
                }
            } else {
                if (val !== '') {
                    this.$store.commit("updateCartPaymentType", val);
                    //這寫法會保留沒異動的值，使用上需嚴謹
                    this.paymentType = Object.assign({}, this.paymentType, val);
                }

                this.showBank = false;
            }
        },

        checkCouponChoiceListItem() {
            let isUpdate = false;
            let isResetCoupon = false;

            Object.keys(this.checkCumulativeTypeList).forEach(index => {
                let item = this.checkCumulativeTypeList[index];
                item.isUpdate = false;
                if (item.posUseCumulativeType === 1 && item.posUseAmount > this.oldOriginTotalPrice) {
                    isUpdate = true;
                    item.isUpdate = true;
                    item.canUseAmount = 0;
                    item.totalChoiceAmount = 0;
                } else if (item.posUseCumulativeType === 2) {
                    let count = Math.floor(this.oldOriginTotalPrice / item.posUseAmount);
                    let canUseAmount = count * item.posUsePieces;
                    if (item.totalChoiceAmount > canUseAmount) {
                        isUpdate = true;
                        item.isUpdate = true;
                        item.canUseAmount = canUseAmount;
                        item.totalChoiceAmount = canUseAmount;
                    }
                }

                if (item.isUpdate && (item.couponTypeId === 1 || item.couponTypeId === 3)) {
                    isResetCoupon = true
                }
            })

            if (isUpdate) {
                let tmpCouponChoiceListItem = JSON.parse(JSON.stringify(this.couponChoiceListItem));
                let newtCouponChoiceListItem = [];

                tmpCouponChoiceListItem.forEach(item => {
                    let couponListId = "couponListId_" + item.couponListId;
                    let checkItem = this.checkCumulativeTypeList[couponListId] || {};
                    if (checkItem.isUpdate) {

                        if (checkItem.canUseAmount === 0) {
                            return false;
                        } else {
                            if (checkItem.canUseAmount >= item.choiceAmount) {
                                checkItem.canUseAmount -= item.choiceAmount;
                                newtCouponChoiceListItem.push(item);
                            } else {
                                item.choiceAmount = checkItem.canUseAmount;
                                checkItem.canUseAmount = 0;
                                newtCouponChoiceListItem.push(item);
                            }
                        }
                    } else {
                        newtCouponChoiceListItem.push(item);
                    }
                })

                this.couponChoiceListItem = newtCouponChoiceListItem;
                this.$store.commit("updateCartcouponChoiceListItem", this.couponChoiceListItem);
            }

            //在購物車減去商品導致金額不足使用兌換、加價券時或從餐點明細回到購物車時
            if (this.isNoteBlock && (isResetCoupon || (this.couponChoiceListItem.length > 0 && (notNull(this.fromRoute) && ['OrderDetail'].indexOf(this.fromRoute.name) !== -1)))) {
                this.$nextTick(() => {
                    clearTimeout(this.noteBlockTimer)
                    this.noteBlockTimer = setTimeout(() => {
                        this.$refs["NoteBlock"].goCoupon(true);
                    }, 300)
                })
            }
        },
        tableOrderAddItem() {
            let self = this;
            self.isLoading = true;
            this.$http.fetch`TableOrderAddItem${{
                orderId: self.orderId,
                tableId: self.tableId,
                storeId: self.storeInfo.id,
                mealApiFormat: self.mealApiFormat(),
            }}
            ${json => {
                self.$public.showNotify(json.message, json.status);
                self.isLoading = false;
                if (json.status) {

                    //避免 updateShopCart 時又把資料insert進去
                    self.isTableOrderComplete = true;
                    self.$public.clearCart(self);
                    self.$store.commit("clearCartPageSnapshot");
                    self.$store.commit("savePageSnapshot", { routeName: "OrderList", variable: undefined });

                    let dataObject = self.dataObject;
                    let dataToken = self.$crypto.objectToURIComponent({
                        "orderId": json.data.orderId,
                        "storeId": json.data.storeId,
                        "usedType": dataObject.usedType,
                        "prototypeObject": { ...dataObject.prototypeObject },
                    })
                    self.$router.push({ path: dataObject.tableOrderRoutePath + "/complete", query: { dataToken: dataToken } });

                    self.analytics.sendEvent(Analytics.EVENTS.SUBMIT_ORDER, {
                        orderId: self.orderId,
                        tableId: self.tableId,
                        storeId: self.storeInfo.id,
                    })
                }
            }}`;
        },

        /** 取得支付方式的名稱 */
        getPaymentName(){
            let self = this;
            let paymentName = "";

            if (self.$public.notNull(self.paymentType)) {
                paymentName = self.paymentType.name;
            }

            return paymentName;
        },

        /** 是否顯示現金支付提醒 */
        isShowCashPayHint(){
            let self = this;

            if (self.$public.notNull(self.paymentType)) {
                return self.paymentType.type === "cash";
            }

            return false;
        },

        /** 手機條碼更新 */
        mobileBarcodeUpdate: function(value) {
            if (this.$public.notNull(value)) {
                this.mobileBarcode = value;
            }
        },

        // 子元件統一編號回傳值
        updateTaxIdNumber(val) {
            if (this.$public.notNull(val)) {
                this.taxIdNumber = val;
            }
        },

        /** 檢查載具與統編, 0:ok, 1:檢查有錯, 2:重複填寫 */
        checkBarcodeAndTaxId() {
            let isMobileBarcodeEmpty = false;
            let isMobileBarcodeOK = false;
            let isTaxIdNumberEmpty = false;
            let isTaxIdNumberOK = false;

            isMobileBarcodeEmpty = !(this.$public.notNull(this.mobileBarcode) && this.mobileBarcode !== '');
            isTaxIdNumberEmpty = !(this.$public.notNull(this.taxIdNumber) && this.taxIdNumber !== '');

            //檢查手機條碼(載具)
            if (!isMobileBarcodeEmpty) {
                isMobileBarcodeOK = this.$public.reg( 'mobileBarcode', this.mobileBarcode, "");
            }
            //檢查統一編號
            if (!isTaxIdNumberEmpty) {
                isTaxIdNumberOK = this.$public.reg( 'taxIdNumber', this.taxIdNumber, "");
            }

            if (isMobileBarcodeEmpty && isTaxIdNumberEmpty) {
                return 0;
            }  else if (!isMobileBarcodeEmpty && !isTaxIdNumberEmpty) {
                //兩個都寫也不行
                return 2;
            } else if (!isMobileBarcodeEmpty && isMobileBarcodeOK) {
                return 0;
            } else if (!isTaxIdNumberEmpty && isTaxIdNumberOK) {
                return 0;
            }
            return 1;
        },
        tokenPayNewebpayMPGComplete(orderSn) {//錢包目前僅能在app使用且不能修改訂單，所以只需清除相關功能
            let self = this
            self.$public.clearCart(self);
            self.$store.commit("clearCartPageSnapshot");
            self.$store.commit("savePageSnapshot", {
                routeName: "payRelationData", variable: {
                    storeId: self.storeInfo.id
                }
            });
            self.orderSn = orderSn
            self.closeSuccessDialog();
        },
        linePayRequestCheck(isConfirm = false) {
            this.isLoading = true
            this.$http.fetchWithAuthEncrypt`LinePayRequestCheck${{
                "action": constDefine.LinePayOnlineApi.Check,
                "payExecuteType": this.payExecuteType,
                "payExecuteId": this.payExecuteId,
                "os": this.$http.getOS(),
            }} ${json => {
                this.isLoading = false
                if (json.status) {
                    if (isConfirm && notNull(json.data)) {
                        let dataObject = this.$crypto.decryptObjectText(json.data.dataToken)
                        if (dataObject.action === constDefine.LinePayOnlineApi.Check) {
                            this.linePayRequestConfirm(dataObject.transactionId, dataObject.tradeNo)
                        } else {
                            this.$public.showNotify("回傳參數異常", false);
                        }
                    }
                } else {
                    this.$public.showNotify(json.message, json.status);
                }
            }}`;
        },
        linePayRequestConfirm(transactionId = "", tradeNo = "") {//消費者確認才扣款建立訂單用
            this.isLoading = true
            this.$http.fetchWithAuthEncrypt`LinePayRequestConfirm${{
                "action": constDefine.LinePayOnlineApi.Request,
                "payExecuteType": this.payExecuteType,
                "payExecuteId": this.payExecuteId,
                "transactionId": transactionId,
                "tradeNo": tradeNo,
                "os": this.$http.getOS(),
            }} ${json => {
                this.isLoading = false
                if (json.status) {
                    this.checkPaymentCompleted(false)
                } else {
                    this.$public.showNotify(json.message, json.status);
                }
            }}`;
        },
        checkPaymentCompleted(isIgnoreNotify = false) {
            let self = this;
            self.$http.fetchWithEncrypt`PaymentCompleted${{
                orderTmpId: self.newOrderTmpId,
            }}
            ${(json) => {
                if (json.status) {
                    //判斷是線上點餐還是桌邊服務
                    if (self.isCordova || self.isOnlineOrder) {
                        //線上點餐
                        self.orderSn = json.data.orderSn;
                        self.closeSuccessDialog();
                    } else {
                        //避免 updateShopCart 時又把資料insert進去
                        //桌邊服務
                        self.isTableOrderComplete = true;

                        self.dataObject = {
                            ...self.dataObject, ...{
                                "takeoutId": json.data.takeoutId,
                            }
                        }
                        sessionStorage.setItem(constDefine.StorageNameType.TableOrderDataToken, self.$crypto.objectToURIComponent(self.dataObject));

                        let dataToken = self.$crypto.objectToURIComponent({
                            "takeoutId": json.data.takeoutId,
                            "storeId": self.dataObject.storeId,
                            "prototypeObject": { ...self.dataObject.prototypeObject },
                        })

                        if (self.dataObject.routePath) {
                            self.$router.push({ path: self.dataObject.routePath + "/complete", query: { dataToken: dataToken } });
                        } else {
                            self.$router.push({ name: 'TableOrderComplete', query: { dataToken: dataToken } });
                        }
                    }
                    self.$public.clearCart(self);
                    self.$store.commit("clearCartPageSnapshot");
                } else {
                    if (!isIgnoreNotify) {
                        self.$public.showNotify('抱歉：' + json.message, json.status);
                    }
                }
            }}`;
        },
        callCheckPaymentCompleted() {
            if (document.visibilityState === "visible") {
                clearTimeout(this.checkPaymentCompletedTimer)
                this.checkPaymentCompletedTimer = setTimeout(() => {
                    this.checkPaymentCompleted(true)
                }, 1000) ;
            }
        },
        openLinePay() {
            let self = this
            let browser = self.$public.getBrowser();
            if (self.isMobile) {
                browser.open(self.paymentUrlApp, "_system", "location=no,toolbar=yes,toolbarposition=top,closebuttoncaption=關閉,closebuttoncolor=#f8de6f,toolbarcolor=#343a40,navigationbuttoncolor=#f8de6f");
            } else if (self.paymentUrlWeb !== "") {
                browser.open(self.paymentUrlWeb, "_block");
            }
        },
    },
    watch: {
        shoppingCartMealChoiceList: {
            handler: function (newVal, oldVal) {
                let sumPrice = 0;
                let sumAmount = 0;
                let originSumPrice = 0;
                for (const key in newVal) {
                    if (Object.hasOwnProperty.call(newVal, key)) {
                        const element = newVal[key];
                        sumPrice += element.choicePrice;
                        sumAmount += element.amount;
                        if (!element.isNewItem) {
                            originSumPrice += (typeof element.originInfo !== "undefined" ? element.originInfo.choicePrice : element.choicePrice);
                        }
                    }
                }
                this.$store.commit("updateCartOriginTotalPrice", sumPrice)
                this.originTotalPrice = sumPrice;
                this.sumAmount = sumAmount;
                this.$store.commit("updateCartOldOriginTotalPrice", originSumPrice)
                this.oldOriginTotalPrice = originSumPrice;
            },
            deep: true,
            immediate: true,
        },
        sumAmount: {
            handler: function (newVal, oldVal) {
                if (newVal === 0 && oldVal !== undefined && oldVal !== 0) {
                    // 購物車無商品自動導回上一頁
                    this.$router.go(-1);
                }
            },
            deep: true,
            immediate: true,
        },
        payResult: {
            handler: function (newVal, oldVal) {
                if (newVal !== '' && newVal.status === true) {
                    this.orderSn = newVal.data.orderSn;
                }
            },
            deep: true,
            immediate: false,
        },
        showBank: {
            handler: function (newVal, oldVal) {
                this.$store.commit("updateCartShowBank", newVal);
            },
            deep: false,
            immediate: false,
        },
        '$store.state.publicCommDialogData.isShowDialog': function() {
            if (this.$route.name === 'OrderCart') {
                if (!this.$store.state.publicCommDialogData.isShowDialog && this.$store.state.publicCommDialogData.isResultEvent) {
                    if (this.$store.state.publicCommDialogData.result &&
                        this.$store.state.publicCommDialogData.eventName === constDefine.triggerCloseBtn) {
                        if (this.dataObject.isWebLogin) {
                            if (typeof this.dataObject.prototypeObject !== "undefined") {
                                let dataObject = {
                                    ...this.dataObject.prototypeObject,
                                    "prototypeObject": {...this.dataObject.prototypeObject},
                                }

                                sessionStorage.setItem(constDefine.StorageNameType.TableOrderDataToken, this.$crypto.objectToURIComponent(dataObject));
                                if (this.dataObject.routePath) {
                                    this.$router.push({ path: this.dataObject.routePath })
                                }
                            }
                        } else {
                            document.getElementById('closeBtn').click()
                        }
                    }

                    this.$store.commit(mutationTypes.setPublicCommDialogData, {
                        isResultEvent: false,
                        eventName: "",
                    });
                }
            }
        },
        checkPaymentCompletedDialog: {
            handler(newVal, oldVal) {
                if (newVal) {
                    document.addEventListener("visibilitychange", this.callCheckPaymentCompleted);
                } else {
                    document.removeEventListener("visibilitychange", this.callCheckPaymentCompleted);
                }
            },
            deep: false,
            immediate: false,
        },
    },
    computed: {
        //訂單即將送出的最終金額
        finalPrice: function () {
            let temp = this.originTotalPrice;

            this.checkCouponChoiceListItem();

            if (this.calculatorCouponPrice !== null) {
                temp = this.calculatorCouponPrice(temp, this.couponChoiceListItem);

                let discountLimitPrice = 0;

                if (notNull(this.discountLimit)) {
                    //自取
                    if (Number(this.radioTake) === constDefine.RADIO_TAKE.takeout) {
                        //金額限制
                        if (this.discountLimit.takeoutDiscountLimitType === 1) {
                            discountLimitPrice = this.discountLimit.takeoutDiscountLimitPrice;
                            //比例限制
                        } else if (this.discountLimit.takeoutDiscountLimitType === 2) {
                            discountLimitPrice = Math.round(this.originTotalPrice * (this.discountLimit.takeoutDiscountLimitPercentage / 100));
                        }
                        //外帶
                    } else if (Number(this.radioTake) === constDefine.RADIO_TAKE.delivery) {
                        //金額限制
                        if (this.discountLimit.deliveryDiscountLimitType === 1) {
                            discountLimitPrice = this.discountLimit.deliveryDiscountLimitPrice;
                            //比例限制
                        } else if (this.discountLimit.deliveryDiscountLimitType === 2) {
                            discountLimitPrice = Math.round(this.originTotalPrice * (this.discountLimit.deliveryDiscountLimitPercentage / 100));
                        }
                    }
                }

                if (discountLimitPrice !== 0 && (this.originTotalPrice - temp > discountLimitPrice)) {
                    temp = this.originTotalPrice - discountLimitPrice;
                }
            }

            this.orderRewardPointInfo.rewardPointList.forEach(item => {
                if(item.isUse) {
                    temp -= Number(item.useAmount)
                }
            })

            this.$store.commit("updateCartDiscountedPrice", temp);

            if (this.radioTake === '2') {
                temp += this.deliveryFee;
            }

            this.$store.commit("updateCartFinalPrice", temp);
            return temp;
        },
        //送出訂單的執行事件
        submitToDo: function () {
            let self = this;

            return function () {
                //能進到這裡就代表有設定過token跟payPassword
                if (self.paymentType.type === "tokenPayNewebpayMPG" && self.payPassword === "") {
                    let routerName = "PayPassword"
                    let dataToken = this.$crypto.objectToURIComponent({
                        usedType: routerName,
                        isHavePayPassword: true,
                        successRouterName: this.$route.name,
                    })

                    self.$router.push({name: routerName, query: {'dataToken': dataToken}})
                    return false
                }

                self.isLoading = true;

                let useRewardPointList = []
                self.orderRewardPointInfo.rewardPointList.forEach(item => {
                    if (item.isUse && item.useAmount > 0) {
                        useRewardPointList.push(JSON.parse(JSON.stringify(item)))
                    }
                })

                //金流專案需要的相關資料
                if(self.paymentType.type === "tokenPayNewebpayMPG") {
                    self.$payment.paymentRequest = {
                        storeToken: self.$crypto.encryptText(String(self.storeInfo.id)),
                        paymentType: self.paymentType.type,
                        paymentInstFlag: self.paymentType.selectFlag.toString(),
                        payPassword: self.payPassword,
                        userPayTokenId: self.paymentType.userPayTokenId,
                    }
                } else if (self.paymentType.type === constDefine.LinePayOnlineApi.Request) {//後續的建立訂單跟推播沿用藍新的概念，所以會用到method、apiToFunc
                    this.$payment.paymentRequest = {
                        method: "online",
                        apiToFunc: "OnlineTradeClose",
                    }
                } else {
                    this.$payment.paymentRequest = {
                        storeToken: this.$crypto.encryptText(String(self.storeInfo.id)),
                        paymentType: self.paymentType.type,
                        paymentInstFlag: self.paymentType.selectFlag.toString(),
                        method: "online",
                        apiToPay: "PayByCreditCard",
                        apiToFunc: "OnlineTradeClose",
                        homeUrl: this.$auth.getCurrentHost(),
                    }
                }

                this.$http.fetchWithAuthEncrypt`CreateOrder2${{
                    storeId: self.storeInfo.id,
                    mealChoiceList: self.shoppingCartMealChoiceList,
                    mealData: self.shoppingCartMealData,
                    remark: self.remark,
                    sumAmount: self.sumAmount,
                    couponChoiceList: self.couponChoiceListItem,
                    taxIdNumber: self.taxIdNumber,
                    carrierNumber: self.mobileBarcode,
                    userAddressId: self.userAddressId,
                    radioTake: parseInt(self.radioTake),
                    isRequiredTableware: self.isRequiredTableware,
                    totalPrice: self.finalPrice,
                    takeoutId: self.takeoutId,
                    paymentType: self.paymentType.type,
                    paymentId: self.paymentType.id,
                    reservationTime: self.storeInfo.reservationTime,
                    mealApiFormat: self.mealApiFormat(),
                    isCordova: self.isCordova,
                    phone: self.phone,
                    countryCode: self.countryCode,
                    countryName: self.countryName,
                    tableId: self.tableId,
                    adult: self.adult,
                    child: self.child,
                    payRequest: self.$payment.paymentRequest,
                    orderSettingTypeId: self.orderSettingTypeId,
                    useRewardPointList: useRewardPointList,
                    userAddressParams: self.userAddressParams,
                    isAppScanOpen: self.isAppScanOpen,
                    os: self.$http.getOS(),
                    isMobile: self.isMobile,
                }}
                    ${async (json) => {
                        self.isLoading = false
                        if (json.status) {
                            if(notNull(json.data)) {
                                self.newOrderTmpId = json.data.orderTmpId || 0
                                self.payExecuteType = json.data.payExecuteType || 0
                                self.payExecuteId = json.data.payExecuteId || 0
                            } else {
                                self.newOrderTmpId = 0
                                self.payExecuteType = 0
                                self.payExecuteId = 0
                            }

                            let metadata;
                            if (this.isOnlineOrder) {
                                metadata = {
                                    storeId: self.storeInfo.id,
                                    totalPrice: self.finalPrice,
                                    paymentType: self.paymentType.type,
                                    paymentId: self.paymentType.id,
                                }
                            } else {
                                metadata = {
                                    phone: self.phone,
                                    tableId: self.tableId,
                                    adult: self.adult,
                                    child: self.child,
                                    storeId: self.storeInfo.id,
                                    totalPrice: self.finalPrice,
                                    paymentType: self.paymentType.type,
                                    paymentId: self.paymentType.id,
                                }
                            }
                            self.analytics.sendEvent(Analytics.EVENTS.SUBMIT_ORDER, metadata)

                            self.$public.showNotify(json.message, json.status);
                            switch (self.paymentType.type) {
                                case 'cash': {
                                    //記住送成功前的購物車頁面資訊
                                    let recordCount = 0;
                                    let dataJson = {};
                                    this.$public.clearCart(self);
                                    this.$store.commit("clearCartPageSnapshot");
                                    if (json.data.takeoutId !== 0) {
                                        self.takeoutId = json.data.takeoutId;
                                    }
                                    for (const key in self._data) {
                                        if (Object.hasOwnProperty.call(self._data, key) && key !== "fromRoute") {
                                            const element = self._data[key];
                                            if (key !== "analytics") {
                                                dataJson[key] = element;
                                            }
                                        }
                                    }
                                    dataJson = JSON.stringify(dataJson);

                                    if (self.isCordova || self.isOnlineOrder) {
                                        self.orderSn = json.data.orderSn
                                        //確認此訂單是否有存在暫存
                                        self.$sqlite.query('select * from order_record_snapshot_data WHERE takeoutId = ?', [Number(self.takeoutId)], (resultSet) => {
                                            recordCount = resultSet.rows.length;
                                            //有的話就更新，沒有的話就新增
                                            if (recordCount > 0) {
                                                self.$sqlite.update('UPDATE order_record_snapshot_data SET data_json=? WHERE takeoutId = ?', [dataJson, self.takeoutId], (resultSet) => {
                                                });
                                            } else {
                                                self.$sqlite.insert('insert into order_record_snapshot_data (orderId,orderSn,takeoutId, data_json) values (?, ?, ?, ?);', [json.data.orderId, json.data.orderSn, json.data.takeoutId, dataJson], (resultSet) => {
                                                });
                                            }
                                        });

                                        self.closeSuccessDialog();
                                    } else {
                                        //避免 updateShopCart 時又把資料insert進去
                                        self.isTableOrderComplete = true;

                                        self.dataObject = {
                                            ...self.dataObject, ...{
                                                "takeoutId": json.data.takeoutId,
                                            }
                                        }
                                        sessionStorage.setItem(constDefine.StorageNameType.TableOrderDataToken, self.$crypto.objectToURIComponent(self.dataObject));

                                        let dataToken = self.$crypto.objectToURIComponent({
                                            "takeoutId": json.data.takeoutId,
                                            "storeId": self.dataObject.storeId,
                                            "prototypeObject": { ...self.dataObject.prototypeObject },
                                        })

                                        if (self.dataObject.routePath) {
                                            self.$router.push({ path: self.dataObject.routePath + "/complete", query: { dataToken: dataToken } });
                                        } else {
                                            self.$router.push({ name: 'TableOrderComplete', query: { dataToken: dataToken } });
                                        }
                                    }
                                    break;
                                }
                                case 'newebpayMPG': {
                                    //信用卡使用的暫存訂單編號
                                    this.$payment.paymentRequest = {
                                        ...this.$payment.paymentRequest, ...{ orderTmpId: json.data.orderTmpId, isApp: this.isCordova, }
                                    }
                                    //確認金流閘道
                                    this.payResult = await this.$payment.getPayment(this.$payment.paymentRequest)
                                    //付款完成彈出視窗內容
                                    if (this.payResult.status === true) {
                                        //判斷是線上點餐還是桌邊服務
                                        if (self.isCordova || self.isOnlineOrder) {
                                            //線上點餐
                                            self.orderSn = this.payResult.data.orderSn;
                                            self.closeSuccessDialog();

                                        } else {
                                            //避免 updateShopCart 時又把資料insert進去
                                            //桌邊服務
                                            self.isTableOrderComplete = true;

                                            self.dataObject = {
                                                ...self.dataObject, ...{
                                                    "takeoutId": this.payResult.data.takeoutId,
                                                }
                                            }
                                            sessionStorage.setItem(constDefine.StorageNameType.TableOrderDataToken, self.$crypto.objectToURIComponent(self.dataObject));

                                            let dataToken = self.$crypto.objectToURIComponent({
                                                "takeoutId": this.payResult.data.takeoutId,
                                                "storeId": self.dataObject.storeId,
                                                "prototypeObject": { ...self.dataObject.prototypeObject },
                                            })

                                            if (self.dataObject.routePath) {
                                                self.$router.push({ path: self.dataObject.routePath + "/complete", query: { dataToken: dataToken } });
                                            } else {
                                                self.$router.push({ name: 'TableOrderComplete', query: { dataToken: dataToken } });
                                            }
                                        }
                                        this.$public.clearCart(self);
                                        this.$store.commit("clearCartPageSnapshot");
                                    } else {
                                        self.$public.showNotify('抱歉：' + this.payResult.message, this.payResult.status);
                                    }

                                    break;
                                }
                                case 'tokenPayNewebpayMPG': {
                                    self.tokenPayNewebpayMPGComplete(json.data.orderSn)
                                    break;
                                }
                                case constDefine.LinePayOnlineApi.Request: {
                                    let browser = self.$public.getBrowser();
                                    if(self.$public.notNull(json.data.paymentUrlApp)) {
                                        self.paymentUrlApp = json.data.paymentUrlApp;
                                        self.paymentUrlWeb = json.data.paymentUrlWeb;
                                    } else {
                                        self.paymentUrlApp = '';
                                        self.paymentUrlWeb = '';
                                    }

                                    if(self.isMobile && self.paymentUrlApp !== "") {
                                        self.checkPaymentCompletedDialog = true
                                        browser.open(self.paymentUrlApp, "_system", "location=no,toolbar=yes,toolbarposition=top,closebuttoncaption=關閉,closebuttoncolor=#f8de6f,toolbarcolor=#343a40,navigationbuttoncolor=#f8de6f");
                                    } else if (self.paymentUrlWeb !== "") {
                                        //避免重複綁定
                                        //當前網頁跟另開網頁要同網域才可以控制
                                        if (self.signalController !== null) {
                                            self.signalController.abort()
                                        }
                                        self.signalController = new AbortController();
                                        let signal = self.signalController.signal
                                        browser.open(self.paymentUrlWeb, "_block");
                                        window.addEventListener(
                                            'message',
                                            (event) => {
                                                self.checkPaymentCompleted(false);
                                                self.signalController.abort()
                                            },
                                            { signal },
                                        );

                                        self.checkPaymentCompletedDialog = true
                                    } else {
                                        self.$public.showNotify('抱歉：支付方式異常，請選擇其他支付方式', false);
                                    }
                                    break;
                                }
                                default: {
                                    self.$public.showNotify('抱歉：' + json.message, json.status);
                                    break;
                                }
                            }
                        } else {
                            if(notNull(json.data)) {
                                //錢包需要3D驗證時
                                if (json.data.is3dVerify && self.paymentType.type === "tokenPayNewebpayMPG") {
                                    let result = await this.$payment.creditCardOpenVerifyWeb(json.data.orderTmpId, json.data.verifyHtml)
                                    if (result.status) {
                                        self.tokenPayNewebpayMPGComplete(result.data.orderSn)
                                    } else {
                                        self.$public.showNotify('抱歉：' + result.message, result.status);
                                    }
                                } else {
                                    self.$public.showNotify(json.message, json.status);
                                }
                            } else {
                                self.$public.showNotify(json.message, json.status);
                            }
                        }
                }}`;
            }
        },
        finalCheck(){
            let self = this;
            return function () {
                if (self.paymentType.name === "" || self.paymentType.name === undefined) {
                    self.$el.style.setProperty('--borderColor333', `${"#EA4E5E"}`)
                    document.getElementById('PayType').scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
                    self.$public.showNotify("請選擇付款方式", false);
                    return false
                } else if (!self.storeInfo.orderStatus && self.storeInfo.reservationTime === "") {
                    self.$public.showNotify("目前僅接收預約訂單", false);
                    self.$store.commit(mutationTypes.setOpenPickTime, true);
                    return false;
                } else if (self.finalPrice < 0) {
                    self.$public.showNotify("結帳金額不可為負數，請調整使用的優惠", false);
                    return false
                }

                if (self.isUserData && self.dataObject.usedType === constDefine.QRCodeUsedType.TableOrder) {
                    let nowTimestamp = new Date().getTime()
                    let validTimestamp = self.dataObject.userData.validTimestamp
                    if (nowTimestamp > validTimestamp) {
                        self.$store.commit(mutationTypes.setPublicCommDialogData, {
                            isShowDialog: true,
                            outerContent: "點餐已逾時",
                            mainContent: `需要重新${self.dataObject.isWebLogin ? "登入" : "掃碼"}點餐嗎？`,
                            isCancel: true,
                            isResultEvent: true,
                            eventName: constDefine.triggerCloseBtn,
                        });
                        return false
                    }
                }

                //檢查載具與統編
                let errorCode = self.checkBarcodeAndTaxId();
                if (errorCode === 0) {
                    self.finalCheckModel = true;

                } else if (errorCode === 1) {
                    self.$public.showNotify("請檢查手機條碼或統一編號是否填寫正確", false);
                } else if (errorCode === 2) {
                    self.$public.showNotify("手機條碼或統一編號只能擇一填寫", false);
                }
            }
        },

        /** 檢查載具與統編 */
        getBarcodeOrTaxId() {
            if ( this.checkBarcodeAndTaxId() === 0) {
                if (this.$public.notNull(this.mobileBarcode) && this.mobileBarcode !== '') {
                    return this.mobileBarcode;

                } else if (this.$public.notNull(this.taxIdNumber) && this.taxIdNumber !== '') {
                    return this.taxIdNumber;
                }
            }
            return '';
        },
    },
    beforeRouteEnter: function(to, from, next) {
        next(
            vm=>{
                // vm就是出去的this，先把來的路由存起來，出去就抓不到了？
                vm.fromRoute = from;
            }
        );
    },
    beforeRouteLeave: function(to, from, next) {
        //有因使用優惠所異動的餐點資料要復原
        //OrderList、OrderDetail 主要異動sqlite或indexDb
        //再透過 MeaIList 去生 shoppingCartMealChoiceList
        //OrderCart、OrderCouponList 也會異動 shoppingCartMealChoiceList
        //updateShopCart 會把 shoppingCartMealChoiceList 異動回sqlite或indexDb
        if (['OrderList', 'OrderDetail'].indexOf(to.name) !== -1) {
            let tmpShoppingCartMealChoiceList = []
            this.$store.state.cartPageSnapshot.shoppingCartMealChoiceList.forEach(item => {
                if (!item.isNewItem) {
                    if (typeof item.originInfo !== "undefined") {
                        item = JSON.parse(JSON.stringify(item.originInfo))
                    }

                    tmpShoppingCartMealChoiceList.push(item)
                }
            })

            this.$store.commit("updateShoppingCartMealChoiceList", JSON.parse(JSON.stringify(tmpShoppingCartMealChoiceList)));
        }

        this.updateShopCart();
        // 如果是'OrderDetail', 'OrderCouponList', 'OrderAddressList', 'EditOrderList', 'OINPay', 'PayPassword'的話就記住快照
        if (['OrderDetail', 'OrderCouponList', 'OrderAddressList', 'EditOrderList', 'OINPay', 'PayPassword'].indexOf(to.name) !== -1) {
            let variable = {};
            for (const key in this._data) {
                if (Object.hasOwnProperty.call(this._data, key)) {
                    const element = this._data[key];
                    if (key !== "analytics") {
                        variable[key] = element;
                    }
                }
            }
            variable.scrollTop = document.querySelector('.main').scrollTop;
            variable.scrollHeight = document.querySelector('.main').scrollHeight;
            this.$store.commit("saveAllCartPageSnapshot", variable);
        }
        if (['OrderHelp'].indexOf(to.name) !== -1) {
            if(this.isCordova) {
                this.$sqlite.delete('delete from order_record_meal_choiceList',[],function(resultSet){});
                this.$sqlite.delete('delete from order_record_meal_data',[],function(resultSet){});
            }
        }
        next();
    },
}
</script>
<style lang="less" scoped src="../../less/order.less"/>
